import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7b571ff3-86db-4bba-ba8e-5f3b9df12e31",
    content: "The geometrical attenuation of a point source is 6 dB / km",
    options: {},
  },
  {
    id: "7e13e8a0-6eb5-4c57-ab85-a4e2aaedbd42",
    content: "Attenuation due to absorption in air are generally neglected",
    options: {},
  },
  {
    id: "1461e499-6f2f-4931-a58e-e1688ad54a1f",
    content: "Influence of wind is important in the case of upwind measurement",
    options: {},
  },
  {
    id: "e9c4d5d0-577a-409d-95d2-c13caf7a72db",
    content: "Finite-Element Method is the most popular method for environmental noise",
    options: {},
  },
  {
    id: "5fc54679-7f99-4bf3-8fcc-851e5d0e4845",
    content: "ISO 9613-2 sums the contributions of the attenuation mechanisms",
    options: {},
  },
  { id: "b832ee51-31d6-4a5b-9639-4d1e82c31d04", content: "ISO 9613-2 is not adapted to downtown cities", options: {} },
];

export const task: Task = {
  id: "be94d05c-f506-4920-a198-e5c4552278da",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "1461e499-6f2f-4931-a58e-e1688ad54a1f",
    "5fc54679-7f99-4bf3-8fcc-851e5d0e4845",
    "b832ee51-31d6-4a5b-9639-4d1e82c31d04",
  ],
};
